import React from "react"
import moment from "moment"

function RentalDurationError(props) {
  const {
    rentalDurationError,
    startDate,
    startTime,
    minRentalHours,
    maxRentalHours,
    minRentalDays
  } = props;

  const start = moment(`${startDate.format('YYYY-MM-DD')} ${startTime}`, 'YYYY-MM-DD HH:mm');

  return (
    <React.Fragment>
      {rentalDurationError === 'tooShort' && (
        <div className="trip-error-message">
          <i className="fas fa-exclamation-circle" style={{ color: '#D93900' }}></i>&nbsp;
          This bike has a <strong>minimum trip length</strong> requirement. Please extend your trip until at least <strong>
          {moment(`${startDate.format('YYYY-MM-DD')} ${startTime}`, 'YYYY-MM-DD HH:mm')
            .add(minRentalHours > 0 ? minRentalHours - 24 : 0, 'hours') // -24 because 1 day already included
            .add(1, 'hour') // to ensure part of next day
            .format('hh:mm A [on] MMM DD')}
            </strong> to book this bike.
        </div>
      )}
      {rentalDurationError === 'tooLong' && (
        <div className="trip-error-message">
          <i className="fas fa-exclamation-circle" style={{ color: '#D93900' }}></i>&nbsp;
          This bike has a <strong>maximum trip length</strong> limit. Please shorten your trip to end by <strong>
            {start.clone().add(maxRentalHours, 'hours').format('hh:mm A [on] MMM DD')}
          </strong>.
        </div>
      )}
    </React.Fragment>
  );
}

export default RentalDurationError

RentalDurationError.defaultProps = {
  rentalDurationError: null
}